import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
    selector: 'lv-tertiary-button',
    templateUrl: './tertiary-button.component.html',
    styleUrls: ['./tertiary-button.component.scss'],
    standalone: false
})
export class TertiaryButtonComponent implements OnInit {

  @Input()
  public label: string;

  @Input()
  public icon: string;

  @Output()
  public clickEvent: EventEmitter<any> = new EventEmitter<any>();

  constructor() {
  }

  ngOnInit(): void {
  }

}
